import { useState } from "react";

export const ShipmentDetailPublish = () => {
    const [tab, setTab] = useState("tab-1");
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">출하 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                    </div>
                </div>
                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>출하번호</th>
                            <td style={{ width: "33.34%" }}>1234_20240505_1</td>
                            <th style={{ width: "16.66%" }}>상태</th>
                            <td>출하요청</td>
                        </tr>
                        <tr>
                            <th>출하일자</th>
                            <td>2024-05-05</td>
                            <th>요청자</th>
                            <td>이소희</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>출하정보</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>품목정보</button>
                    <button type="button" className={tab == "tab-3" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-3")}>거래처정보</button>
                    <button type="button" className={tab == "tab-4" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-4")}>이전 결제 건</button>
                    <button type="button" className={tab == "tab-5" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-5")}>출하자료</button>
                </div>
                {tab == "tab-1" && <div className="mybtns_group_toolbar">
                    <button type="button" className="btn btn-primary w-80px">출하</button>
                    <button type="button" className="btn btn-primary color2 w-80px">이관</button>
                </div>}
                {tab == "tab-3" && <div className="mybtns_group_toolbar">
                    <button type="button" className="btn btn-primary w-80px">출하</button>
                    <button type="button" className="btn btn-primary color2 w-80px">이관</button>
                    <button type="button" className="btn btn-info color2 w-80px ms-5px">마감</button>
                </div>}
            </div>

            {tab == "tab-1" && <div className="content_wrap">
                <h5 className="subheading">고객정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>고객사</th>
                            <td style={{ width: "33.34%" }}>(주)구구구</td>
                            <th style={{ width: "16.66%" }}>수주고객</th>
                            <td><div className="d-flex">000 대리 <span class="badge rounded-pill bg-primary my_badge ms-10px">주문한 고객</span></div></td>
                        </tr>
                        <tr>
                            <th>담당자</th>
                            <td>김내부</td>
                            <th>요청자</th>
                            <td>택배</td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">발송정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>발송방법</th>
                            <td style={{ width: "33.34%" }}>택배</td>
                            <th style={{ width: "16.66%" }}>발송요청일</th>
                            <td>2024.05.09</td>
                        </tr>
                        <tr>
                            <th>수신자</th>
                            <td>김과장</td>
                            <th>연락처</th>
                            <td>010-1234-1234</td>
                        </tr>
                        <tr>
                            <th>주소</th>
                            <td colSpan={3}>경기도 성남시 분당구 00000000</td>
                        </tr>
                        <tr>
                            <th>메모</th>
                            <td>기타사항</td>
                            <th>기타사항</th>
                            <td>010-1234-1234</td>
                        </tr>
                        <tr>
                            <th>고객메모</th>
                            <td colSpan={3}></td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">납품정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>납품처</th>
                            <td style={{ width: "33.34%" }}><div className="d-flex">주식회사 구구구 <span class="badge rounded-pill bg-warning my_badge ms-10px">ERP 거래처명</span></div></td>
                            <th style={{ width: "16.66%" }}>매출처</th>
                            <td>주식회사 구구구</td>
                        </tr>
                        <tr>
                            <th>수주일자</th>
                            <td>2024-05-05</td>
                            <th>수주번호</th>
                            <td>134-13-1111</td>
                        </tr>
                        <tr>
                            <th>출하일자</th>
                            <td></td>
                            <th>출하번호</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>수주 유형</th>
                            <td>로열티매출(세금계산서)</td>
                            <th>Vat 구분</th>
                            <td>과세(세금계산서)</td>
                        </tr>
                        <tr>
                            <th>수주 유형</th>
                            <td>로열티매출(세금계산서)</td>
                            <th>Vat 구분</th>
                            <td>과세(세금계산서)</td>
                        </tr>
                        <tr>
                            <th>산업구분 <span className="required">*</span></th>
                            <td></td>
                            <th>Application <span className="required">*</span></th>
                            <td></td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">수금정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>수금예정일<span className="required">*</span></th>
                            <td style={{ width: "33.34%" }}></td>
                            <th style={{ width: "16.66%" }}>결제방법<span className="required">*</span></th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>수금메모(세금계산서 비고)</th>
                            <td colSpan={3}></td>
                        </tr>
                        <tr>
                            <th>계산서담당자</th>
                            <td>김과장</td>
                            <th>연락처</th>
                            <td>010-1234-1234</td>
                        </tr>
                        <tr>
                            <th>이메일</th>
                            <td colSpan={3}>aaa@it.com</td>
                        </tr>
                    </tbody>
                </table>
            </div>}

            {tab == "tab-3" && <div className="content_wrap">
                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>환율 지정 조건</th>
                            <td style={{ width: "11.1%" }}>일평균</td>
                            <td style={{ width: "11.1%" }}>최초 고시</td>
                            <td>송금 보낼 때</td>
                            <th style={{ width: "16.66%" }}>결제일</th>
                            <td style={{ width: "16.65%" }}>매월</td>
                            <td>말일</td>
                        </tr>
                        <tr>
                            <th>미수채권</th>
                            <td colSpan={6}>
                                <div className="unit_cost">
                                    <span>￦</span> <span>132,800</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">PTA</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>CLA Number</th>
                            <td style={{ width: "33.34%" }}>1909953</td>
                            <th style={{ width: "16.66%" }}>Company ID</th>
                            <td>16655555</td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">PTA 목록</h5>
                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "6.28%" }}>N0</th>
                                <th style={{ width: "15.72%" }}>Product Group</th>
                                <th style={{ width: "23.64%" }}>벤더</th>
                                <th style={{ width: "26.41%" }}>Pricing Group</th>
                                <th style={{ width: "7.54%" }}>Currency Type</th>
                                <th style={{ width: "6.54%" }}>Pricing Tier</th>
                                <th style={{ width: "6.28%" }}>Price</th>
                                <th>ERP코드</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (<tr>
                                <td className="text-center">1</td>
                                <td>IoT</td>
                                <td>Win Svr Emb Std 2012 x64 EMB ESD OEI 2 CU Std</td>
                                <td>Windows Svr Std Ent DC</td>
                                <td className="text-center">USD</td>
                                <td className="text-center">B</td>
                                <td className="text-center">50</td>
                                <td className="text-center">310</td>
                            </tr>))}
                        </tbody>
                    </table>
                </div>
                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>}
        </>
    );
}